import { queryOptions } from '@tanstack/react-query'
import { apiClient } from '~/lib/client'

import { handleApiError } from '~/utils/response'
import { handleResponse } from '~/utils/response'

import { encounterKeys } from './keys'
import { EncounterType, GetEncounterResponse, GetEncountersResponse,GetChatHistoryResponse } from '../types'

export const encountersQueryOptions = (params: {
    page?: number
    limit?: number
    disease_name?: string
    sort?: string
    sort_by?: string,
    date_filter?: string,
    type?: EncounterType
}) => {
    return queryOptions({
        queryKey: encounterKeys.encounters(),
        retry: false,
        queryFn: async () => {
            try {
                const response = await apiClient(`/sessions?${new URLSearchParams(params as Record<string, string>).toString()}`);

                const result = await handleResponse<GetEncountersResponse>(response);
                if (!result.success) {
                    throw new Error(result.error);
                  }
                  return result.data;
            } catch (error) {
                handleApiError(error);
            }
        },
    });
};
 export const anonymousEncounterQueryOptions = (session_id: string) => {
    return queryOptions({
        queryKey: encounterKeys.anonymousEncounter(session_id),
        retry: false,
        queryFn: async () => {
            try {
                const response = await apiClient(`/sessions/anonymous/${session_id}`);

                const result = await handleResponse<GetEncounterResponse>(response);
                if (!result.success) {
                    throw new Error(result.error);
                  }
                  return result.data;
            } catch (error) {
                handleApiError(error);
            }
        },
    });
};

export const encounterQueryOptions = (session_id: string) => {
    return queryOptions({
        queryKey: encounterKeys.encounter(session_id),
        retry: false,
        queryFn: async () => {
            try {
                const response = await apiClient(`/sessions/${session_id}`);

                const result = await handleResponse<GetEncounterResponse>(response);
                if (!result.success) {
                    throw new Error(result.error);
                  }
                  return result.data;
            } catch (error) {
                handleApiError(error);
            }
        },
        enabled: !!session_id
    });
};

 export const chatHistoryQueryOptions = (session_id: string) => {
    return queryOptions({
        queryKey: encounterKeys.chatHistory(session_id),
        retry: false,
        queryFn: async () => {
            try {
                const response = await apiClient(`/sessions/${session_id}/chat-history`);

                const result = await handleResponse<GetChatHistoryResponse>(response);
                if (!result.success) {
                    throw new Error(result.error);
                  }
                  return result.data;
            } catch (error) {
                handleApiError(error);
            }
        },
                enabled: !!session_id
    });
};
 export const appointmentsQueryOptions = (session_id: string) => {
    return queryOptions({
        queryKey: encounterKeys.appointments(session_id),
        retry: false,
        queryFn: async () => {
            try {
                const response = await apiClient(`/sessions/${session_id}/appointments`);
                const result = await handleResponse<GetEncounterResponse>(response);
                if (!result.success) {  
                    throw new Error(result.error);
                  }
                  console.log('appointment',response)
                  return result.data;
            } catch (error) {
                handleApiError(error);
            }
        },
          enabled: !!session_id
    });
};
export const prescriptionsQueryOptions = (session_id: string) => {
    return queryOptions({
        queryKey: encounterKeys.prescriptions(session_id),
        retry: false,
        queryFn: async () => {
            try {
                const response = await apiClient(`/sessions/${session_id}/prescriptions`);
                const result = await handleResponse<GetEncounterResponse>(response);
                if (!result.success) {  
                    throw new Error(result.error);
                  }
                  console.log('prescriptions',response)
                  return result.data;
            } catch (error) {
                handleApiError(error);
            }
        },
          enabled: !!session_id
    });
};